import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { Cont } from './styled'

const InformationComponent = (props) => {

  const { 
    valueForm,
    companyOptions,
    bankOwnerOptions,
    change,
    // props
    isCreate=false,
    isEdit=false,
    onChangeCompany=null,
    onChangeBank=null
  } = props

  const getCompanyName = (companyCode) =>{
    let company = companyOptions.data.find((x)=>x.value==companyCode)
    if(company){
      return company.text
    }else{
      return companyCode
    }
  }

  return (
    <StdCard title={<span className='stepTitle'>Information</span>} flexZero>
      <Cont>
        <RowFields>
          <Field 
            name="active"
            label="Active"
            component={FieldInput}
            type={type.checkbox}
            editable={isCreate||isEdit}
            fieldInputStyle={{justifyContent:'center'}}
            specialOnChange={(value)=>{
              change('formBGLimitOfBank','alert',value)
            }}
          />
        </RowFields>
        <RowFields>
          <Field 
            name="alert"
            label="Alert warning balance lower 5%"
            component={FieldInput}
            type={type.checkbox}
            editable={false}
            fieldInputStyle={{justifyContent:'center'}}
          />
        </RowFields>
        <RowFields>
          <Field 
            name='companyCode' 
            label='Company'
            require 
            options={companyOptions.data} 
            loading={companyOptions.loading}
            editable={isCreate}
            type={type.select} 
            component={FieldInput} 
            specialOnChange={(value)=>{
              change('formBGLimitOfBank','companyName',getCompanyName(value))
              if(onChangeCompany)onChangeCompany(value)
            }}
          />
          <Field 
            name='bankName' 
            label='Bank'
            require 
            options={bankOwnerOptions.data} 
            loading={bankOwnerOptions.loading}
            editable={isCreate}
            type={type.select} 
            component={FieldInput} 
            specialOnChange={(value)=>{
              if(onChangeBank)onChangeBank(value)
            }}
          />
        </RowFields>
        <RowFields>
          <Field 
            name='limit'
            label='Limit(THB)'
            type={type.number}
            editable={isCreate||isEdit}
            component={FieldInput}
            className='halfRow'
            require
          />
          {valueForm.id?
          <Field 
            name='balance'
            label='Balance(THB)'
            type={type.number}
            component={FieldInput} 
            editable={false}
          />:null
          }
        </RowFields>
        <RowFields>
          <Field 
            name='usage'
            label='Usage(THB)'
            type={type.number}
            editable={false}
            component={FieldInput}
            className='halfRow'
          />
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGLimitOfBank')(state) || {},
    companyOptions: state.options.companies,
    bankOwnerOptions: state.bg.bankOwners,
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(InformationComponent)
